const locale = {
  MODAL_AUTHENTICATION_PRINCIPAL_TITLE: 'Two-Step Authentication',
  MODAL_AUTHENTICATION_SUBTITLE: 'What is it?',
  MODAL_AUTHENTICATION_SUBTITLE_DESCRIPTION: `Two-Factor Authentication or 2FA adds an extra layer of security. Instead of just using your password, you'll also need a verification code sent to your phone to log in. This helps protect your account from unauthorized access.`,
  MODAL_AUTHENTICATION_OFF_SWITCH_TITLE: 'Turn on 2FA verification using the toggle',
  MODAL_AUTHENTICATION_ON_SWITCH_TITLE: '2FA has been enabled for your account!',
  MODAL_AUTHENTICATION_ON_SWITCH_DESCRIPTION:
    'Your two-factor authentication code has been sent to your email. Please enter it to continue browsing the platform.',
  LOADING_TEXT: 'Loading',

  SET_OFF_TITLE_TEXT: '2FA not activated',
  SET_OFF_DESCRIPTION_TEXT: 'The activation was not completed.',
};

export default locale;
